export type DomainErrorCode =
  | 'subscription_required'
  | 'not_found'
  | 'invalid_transition'
  | 'invalid_input'
  | 'completed_locked';

/** Erro de regra de negócio, com mensagem pronta para mostrar na tela. */
export class DomainError extends Error {
  constructor(
    readonly code: DomainErrorCode,
    message: string,
  ) {
    super(message);
    this.name = 'DomainError';
  }
}
